import React, {useContext, useState, useEffect} from "react";
import "./Talks.scss";
import TalkCard from "../../components/talkCard/TalkCard";
import {talkSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

const MOBILE_BREAKPOINT = 768;
const MOBILE_COLLAPSED_COUNT = 3;

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= MOBILE_BREAKPOINT
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return isMobile;
}

export default function Talk() {
  const {isDark} = useContext(StyleContext);
  const isMobile = useIsMobile();
  const [expanded, setExpanded] = useState(false);

  if (!talkSection.display) {
    return null;
  }

  const collapse = isMobile && !expanded;
  const visibleTalks = collapse
    ? talkSection.talks.slice(0, MOBILE_COLLAPSED_COUNT)
    : talkSection.talks;
  const hiddenCount = talkSection.talks.length - MOBILE_COLLAPSED_COUNT;

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="talks">
        <div className="achievement-main-div">
          <div className="achievement-header">
            <h1
              className={
                isDark
                  ? "dark-mode heading achievement-heading"
                  : "heading achievement-heading"
              }
            >
              {talkSection.title}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle achievement-subtitle"
                  : "subTitle achievement-subtitle"
              }
            >
              {talkSection.subtitle}
            </p>
          </div>
          <div className="achievement-cards-div">
            {visibleTalks.map((card, i) => {
              return (
                <TalkCard
                  key={i}
                  isDark={isDark}
                  cardInfo={{
                    title: card.title,
                    description: card.subtitle,
                    image: card.image,
                    footer: card.footerLink
                  }}
                />
              );
            })}
          </div>

          {isMobile && hiddenCount > 0 && (
            <div className="talks-toggle-div">
              <button
                className={isDark ? "dark-mode talks-toggle-btn" : "talks-toggle-btn"}
                onClick={() => setExpanded(e => !e)}
                aria-expanded={expanded}
              >
                {expanded
                  ? "Show less ↑"
                  : `See ${hiddenCount} more ${hiddenCount === 1 ? "talk" : "talks"} ↓`}
              </button>
            </div>
          )}
        </div>
      </div>
    </Fade>
  );
}
